import { render, staticRenderFns } from "./ManageProcessContentItem.vue?vue&type=template&id=9c4a0b6a&scoped=true&"
import script from "./ManageProcessContentItem.vue?vue&type=script&lang=js&"
export * from "./ManageProcessContentItem.vue?vue&type=script&lang=js&"
import style0 from "./ManageProcessContentItem.vue?vue&type=style&index=0&id=9c4a0b6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4a0b6a",
  null
  
)

export default component.exports